import { CATMANVIEW } from '../../constants/constant';
import {
	getAxiosAuthHeader,
	checkStatus,
	getmodifiedApiendpoint,
} from '../../helper/utils';

export const getData = async (api, userInfo) => {
	const currView = sessionStorage.getItem('view');
	const view = currView === CATMANVIEW ? 'CATMAN' : 'SUPPLIER';
	let catmanapi = getmodifiedApiendpoint(api, view);
	const { headers } = getAxiosAuthHeader(userInfo);
	try {
		const response = await fetch(catmanapi, {
			method: 'GET',
			headers: {
				...headers,
			},
		});
		checkStatus(response?.status);
		const statusCode = response?.status;
		const json = statusCode === 204 ? '' : await response?.json();
		return { ok: response.ok, json, statusCode };
	} catch (error) {
		console.error(error.message);
	}
};
